DJ.addBehavior('filter', '.filter-container', {
    attach: function (context, settings, behavior) {

      jQuery(document).find('.is-count').html(jQuery(document).find('.sidebar-filter input:not(.visually-hidden):checked').length);

      const sidebar = this;

      const handleTrigger = () => {
        const isOpen = jQuery(sidebar).find('.sidebar-filter').toggleClass('opened').hasClass('opened');
        if (trigger) {
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      }

      const trigger = sidebar.querySelector('.js-mobile-open-filter');
      if (trigger) {
        trigger.addEventListener('click', handleTrigger);
      }

      const submitButton = sidebar.querySelector('.js-submit-trigger');
      submitButton.removeEventListener('click', handleTrigger);

      jQuery(document).find('.sidebar-filter input').on('change', (function () {
          jQuery(document).find('.is-count').html(jQuery(document).find('.sidebar-filter input:not(.visually-hidden):checked').length);
      }));
    },

    detach: function (context, settings) {}
});
